<template>
  <svg viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.19884 5.28752C3.25184 5.19854 3.27964 5.15277 3.3064 5.10615C4.34644 3.30065 5.57797 1.66971 7.01475 0.224685C7.16752 0.0708868 7.32445 -0.00615451 7.53542 0.000384049C7.96723 0.0140297 8.39931 0.00464833 8.83138 0.00464833C8.87347 0.00464833 8.91556 0.00464833 9 0.00464833C6.70739 2.72469 4.80918 5.70002 3.29081 9C3.25834 8.93007 3.23495 8.88401 3.21521 8.83597C2.75144 7.70849 2.17439 6.66119 1.40118 5.75176C0.999501 5.27928 0.560673 4.85342 0.0766364 4.48527C-0.0020877 4.42528 -0.0140392 4.37212 0.0132414 4.27802C0.102618 3.97156 0.09976 3.97156 0.387376 3.96673C0.767486 3.96019 1.14786 3.94342 1.52771 3.94967C1.64176 3.95138 1.76778 3.9909 1.86677 4.05372C2.32898 4.34682 2.74026 4.71355 3.10712 5.13912C3.13908 5.17608 3.16013 5.22412 3.1991 5.28809L3.19884 5.28752Z"/>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 9px;
  height: 9px;
}
</style>